import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "RESTORE_CARRIER_" }
);

export interface RestoreCarrierState {
  loading: boolean;
  error: string | null;
}

const INITIAL_STATE: RestoreCarrierState = {
  loading: false,
  error: null,
};

const request = (state: RestoreCarrierState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: RestoreCarrierState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: RestoreCarrierState, action: any) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const restoreCarrier = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const RestoreCarrierTypes = Types;
export const RestoreCarrierActions = Creators;